<app-si-dialog modalBodyClasses="p-4" [header]="data.title" modalFooterClasses="si-dialog__footer--centered">
	<ng-template appDialogBody>
		<form [formGroup]="promptForm" (ngSubmit)="submitPrompt()" novalidate>
			<ng-container *ngIf="accuracyTier">
				<div class="mb-4 text-center rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm">{{accuracyTierText}}</div>
			</ng-container>

			<ng-container *ngIf="!(data.isContactCsvExport || data.isCompanyExport || data.isCompanyExportAll); else csvContactExportModalBody">
				<ng-container *ngIf="!data.isFileName">
					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-full px-2">
							<mat-form-field *ngIf="data.mandatoryInput" appearance="outline" class="mb-2 w-full">
								<mat-label *ngIf="data.labelText">{{data.labelText}}</mat-label>
								<textarea matInput rows="4" cols="50" formControlName="inputValue"
										  placeholder="{{data.placeHolderText}}"
										  required="{{data.mandatoryInput}}"></textarea>
							</mat-form-field>
						</div>
						<div class="w-full md:flex-none md:w-full text-center mt-6 px-2"  *ngIf="data.exportMessage">
							<span class="text-center"><strong> {{data.exportMessage}}...</strong></span>
						</div>
						<div class="w-full md:flex-none md:w-full mb-0 px-2" *ngIf="data.isReportingModal">
							<div class="w-full sm:flex-none sm:w-full pl-1">
								<mat-checkbox
										id="report"
										formControlName="reportCheckBox"
								><span class="text-[16px]">Yes, perform research request and send me updated information</span></mat-checkbox>
							</div>
						</div>
					</div>
				</ng-container>
			<div class="flex items-center justify-center" *ngIf="data.isFileName">
				<div class="container mx-auto px-4">
					<div class="flex flex-wrap -mx-2 si-form-row">
						<label class="w-full sm:flex-none sm:w-1/4 px-2 self-center">
							{{data.labelText}}:
						</label>
						<div class="w-full sm:flex-none sm:w-2/3 px-2">
							<mat-form-field appearance="outline" class="mb-2 w-full">
								<mat-label>{{data.labelText}}</mat-label>
								<input matInput formControlName="inputValue" placeholder="{{data.placeHolderText}}" required="{{data.mandatoryInput}}"/>
							</mat-form-field>
						</div>
					</div>
				</div>
			</div>
			</ng-container>

			<ng-template #csvContactExportModalBody>
				<div class="flex items-center justify-center">
					<div class="container mx-auto px-4">
						<div class="flex flex-wrap -mx-2 mb-2">
							<div class="flex-none w-5/6 ml-[8.333333%] px-2">
								<h5 class="text-center">
									{{data.exportMessage}}
								</h5>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2 si-form-row">
							<label class="w-full sm:flex-none sm:w-1/4 px-2 self-center">
								{{data.labelText}}:
							</label>
							<div class="w-full sm:flex-none sm:w-2/3 px-2">
								<mat-form-field appearance="outline" class="mb-2 w-full">
									<mat-label>{{data.labelText}}</mat-label>
									<input matInput formControlName="inputValue" [placeholder]="data.placeHolderText || data.labelText"/>
									<mat-error *ngIf="promptForm.hasError('required', ['inputValue'])">
										This field is required.
									</mat-error>
									<mat-error *ngIf="promptForm.hasError('pattern', ['inputValue'])">
										Your file name includes unsupported characters. File names can include letters, numbers, the characters .?!,&#64;&_- and spaces.
									</mat-error>
									<mat-error *ngIf="promptForm.hasError('maxlength', ['inputValue'])">
										Maximum 100 characters is allowed.
									</mat-error>
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>
			</ng-template>
		</form>
	</ng-template>

	<ng-template appDialogFooter>
		<ng-container *ngIf="data.closeButtonText">
			<button matButton="outlined" type="button" (click)="closeModal()">{{data.closeButtonText}}</button>
			<button matButton="filled" [disabled]="promptForm.invalid" (click)="submitPrompt()">{{data.saveButtonText}}</button>
		</ng-container>
	</ng-template>
</app-si-dialog>
